/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCoolingRegimeProductGroupDtoFromDiscriminatorValue, type CoolingRegimeProductGroupDto } from '../../../../models/index.js';
// @ts-ignore
import { createODataErrorFromDiscriminatorValue, type ODataError } from '../../../../models/oDataErrors/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Provides operations to manage the coolingRegimeProductGroups property of the AapService.ProductGroupDto entity.
 */
export interface WithCoolingRegimeProductGroupItemRequestBuilder extends BaseRequestBuilder<WithCoolingRegimeProductGroupItemRequestBuilder> {
    /**
     * Get coolingRegimeProductGroups from ProductGroupOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CoolingRegimeProductGroupDto>}
     * @throws {ODataError} error when the service returns a 4XX or 5XX status code
     */
     get(requestConfiguration?: RequestConfiguration<WithCoolingRegimeProductGroupItemRequestBuilderGetQueryParameters> | undefined) : Promise<CoolingRegimeProductGroupDto | undefined>;
    /**
     * Get coolingRegimeProductGroups from ProductGroupOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithCoolingRegimeProductGroupItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get coolingRegimeProductGroups from ProductGroupOverview
 */
export interface WithCoolingRegimeProductGroupItemRequestBuilderGetQueryParameters {
    /**
     * Expand related entities
     */
    expand?: string[];
    /**
     * Select properties to be returned
     */
    select?: string[];
}
/**
 * Uri template for the request builder.
 */
export const WithCoolingRegimeProductGroupItemRequestBuilderUriTemplate = "{+baseurl}/ProductGroupOverview/{code}/coolingRegimeProductGroups/{coolingRegimeProductGroupId}{?%24expand,%24select}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const WithCoolingRegimeProductGroupItemRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "expand": "%24expand",
    "select": "%24select",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCoolingRegimeProductGroupItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCoolingRegimeProductGroupItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            XXX: createODataErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCoolingRegimeProductGroupDtoFromDiscriminatorValue,
        queryParametersMapper: WithCoolingRegimeProductGroupItemRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
